import React, { Component } from "react";
import NavBar from "../../shared/NavBar";

export class itemPipeline extends Component {
  render() {
    return (
      <div>
        <NavBar />
      </div>
    );
  }
}

export default itemPipeline;
